<template>
  <div class="layout-error">
    <div class="content">
      <!-- // TODO รูป Page Not Found  -->
      <object
        id="error-img"
        type="image/svg+xml"
        :data="image"
        alt="image not found image"
        class="img"
      />

      <!-- // TODO ข้อความ Error -->
      <div class="text">
        <div class="title-text">{{ title }}</div>
        <div class="description-text">{{ description }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: String,
      default: require('@/assets/images/notify.svg')
    },
    title: {
      type: String,
      default: 'เกิดข้อผิดผลาด'
    },
    description: {
      type: String,
      default: 'กรุณาติดต่อผู้ดูแลระบบ'
    }
  }
}
</script>

<style lang="scss" scoped>
// TODO Layout Error Style
.layout-error {
  width: 100%;
  height: 100%;
  display: inline-block;
  padding: 0;
  margin: 0;
  // background: pink;
  position: absolute;
}
.layout-error .content {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  // background: red;
  max-width: 500px;
  max-height: 500px;
  // min-height: 200px;
  // min-width: 200px;
  overflow: hidden;
}

.layout-error .content .img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  // background-color: blue;
}

.layout-error .content .text {
  text-align: center;
}
</style>
